<template>
  <div class="box" style="width: 600px">
    <div>
      <p class="is-size-5 has-text-weight-bold">
       <translate>savedViews.heading</translate>
      </p>
    </div>

    <template v-if="savedViews.length > 0">
    <div v-for="group in allGroups" :key="group" style="margin-top: 20px">
      <template v-if="savedViewsForGroup(group).length > 0">
        <strong>
          <translate>
            {{ group[0].toUpperCase() + group.slice(1) }}
          </translate>
        </strong>
        <div class="saved-view" v-for="(view, i) in savedViewsForGroup(group)" :key="i">
          <div class="level" style="margin-left: 1rem">
            <span class="level-left" style="width: 280px; text-overflow: ellipsis; overflow: hidden">{{ view.name }}</span>
            <div class="level-right">
              <b-tooltip square position="is-top" :label="$gettext('savedView.button.activate.toolTip')">
              <button @click="switchView(view.id)" class="button is-aquamarine">
                <translate>
                  savedView.button.activate
                </translate>
              </button>
              </b-tooltip>
              <b-tooltip square position="is-top" type="is-danger" :label="$gettext('savedView.button.delete.toolTip')">
                <button tabindex="-1" @click="deleteView(view.id)" class="button is-danger" style="margin: 0 0 0 10px">
                  <b-icon icon="times" size="is-small"></b-icon>
                </button>
              </b-tooltip>
            </div>
          </div>
        </div>
      </template>
    </div>
    </template>

    <template v-else>
      <div class="section">
      <i><translate>savedViews.noneSaved</translate></i>
      </div>
    </template>

  </div>
</template>

<script>
import Selection from '@/schema/Selection'

export default {
  computed: {
    savedViews () {
      return this.$store.getters['user/getSavedViews']
    },
    groups () {
      return this.savedViews
        .map(x => x.className)
        .reduce((x, y) => x.includes(y) ? x : [...x, y], [])
    },
    allGroups () {
      return Selection(this.$store.getters['user/getUser'])
        .map(x => x.entities.map(y => y.className))
        .reduce((x, y) => x.concat(y), [])
    }
  },
  methods: {
    savedViewsForGroup (group) {
      return this.savedViews.filter(x => x.className === group)
    },
    switchView (index) {
      this.$store.dispatch('list/switchView', index)
      this.$router.push({name: 'auflisten'})
    },
    deleteView (index) {
      this.$store.dispatch('user/deleteView', index)
    }
  }
}
</script>

<style>

.saved-view {
    margin: 20px 0 20px 0;
}

.saved-view:hover .level .level-left {
  font-weight: bold;
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// src/components/SavedViews.vue